<!--  -->
<template>
  <el-dialog
    title="需求计划跟踪"
    :visible.sync="trackVisibleDia"
    width="600px"
    :before-close="handleClose"
    class="track-dia"
    append-to-body
  >
    <el-tabs v-model="name" type="card">
      <el-tab-pane
        v-for="item of tabList"
        :key="item.name"
        :label="item.trackLogName"
        :name="item.name"
      >
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in item.purchaseTrackLogListVO"
            :key="index"
            :timestamp="activity.createTime"
          >
            <div>{{ activity.purchaseTrackStatusDesc }}</div>
            <div>
              <span>{{ activity.logReceiptNumberDesc }}</span>
              <!--  -->
              <span
                v-if="activity.hasAuth"
                class="link"
                @click="goUrl(activity)"
              >
                {{ activity.businessCode }}
              </span>
              <span v-else>{{ activity.businessCode }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer">
      <eui-btn @click="handleClose" type="primary">关闭</eui-btn>
    </div>
  </el-dialog>
</template>

<script>
import { mallBaseUrl } from '@/modules/projectA/api/urlConfig';
import Api from '@/modules/projectA/api/purchase/index';
import enApi from '@/modules/projectA/api/enquiry/index';
export default {
  props: {
    trackVisibleDia: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {
      name: '1',
      /* tabList: [
        {
          name: "1",
          trackLogName: "tab名字1",
          purchaseTrackLogListVO: [
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
          ],
        },
        {
          name: "2",
          trackLogName: "tab名字2",
          purchaseTrackLogListVO: [
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.22 19:02:30",
            },
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
          ],
        },
        {
          name: "3",
          trackLogName: "tab名字3",
          purchaseTrackLogListVO: [
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.33 19:02:30",
            },
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
          ],
        },
        {
          name: "4",
          trackLogName: "tab名字3",
          purchaseTrackLogListVO: [
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.44 19:02:30",
            },
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
            {
              purchaseTrackStatusDesc: "啦啦啦啦啦",
              creatTime: "2022.11.11 19:02:30",
            },
          ],
        },
      ], */
      tabList: [],
      /*
      需求计划编号：[需求计划创建,需求计划提交, 需求计划审核通过,需求计划审核驳回,需求计划终止,需求计划退回]:需求计划跟踪:/user/user/requirement/track
      采购计划编号：[采购计划创建,采购计划提交,采购计划审核通过,采购计划审核驳回,采购计划退回,采购计划终止]:采购计划查询:/user/user/purchaseWay/purchaseQuery
      订单编号：[订单提交,订单取消]:订单管理:/user/user/userOrder
      询比价编号：[询比价创建,询比价发布]:询比价管理:/user/user/enquiry/enquiryManage
     */
    };
  },
  computed: {},
  watch: {
    trackVisibleDia(newVal) {
      if (newVal) {
        this.getList();
      }
    },
  },
  methods: {
    //
    async getList() {
      this.tabList = [];
      const {
        purchaseDemandId,
        purchaseDemandItemId,
        purchasePlanId,
        purchasePlanItemId,
      } = this.row;
      let params = null;
      if (this.type) {
        params = { purchasePlanId, purchasePlanItemId };
      } else {
        params = { purchaseDemandItemId, purchaseDemandId };
      }
      const res = await Api.logQueryList(params);
      const result = await Api.purchaseMenuList();
      console.log(result, 'result');
      if (res.code === '200') {
        res.data.forEach((item, index) => {
          item.name = `${index + 1}`;
          item.purchaseTrackLogListVO.forEach((iten) => {
            switch (iten.logReceiptNumberDesc) {
              case '需求计划编号：':
                iten.url = `/demand/demandManage/demandDetail?purchaseDemandId=${iten.businessId}`;
                iten.authority = '/demand/track';
                iten.logReceiptNumberDescSelf = '';
                break;
              case '采购计划编号：':
                iten.url = `/plan/purchaseQuery/purchaseDetail?purchasePlanId=${iten.businessId}`;
                iten.authority = '/plan/purchaseQuery';
                break;
              case '订单编号：':
                iten.url = `/user/user/order/orderDetailOrApprove?orderId=${iten.businessId}&orderFlag=orderDetail`;
                // iten.url = `/orderDetailOrConfirm?orderId=${iten.businessId}&type=orderDetail&purchaseCompanyId=${iten.purchaseCompanyId}&orderNo=${iten.businessCode}`;
                iten.authority = '/user/user/order/orderDetailOrApprove';
                break;
              case '询比价编号：':
                iten.url = '';
                iten.authority = '/enquiryManage/enquiry';
                break;
            }
            result.data.forEach((itez) => {
              if (iten.authority === itez.authCode) {
                iten.hasAuth = true;
              }
            });
          });
        });
        this.tabList = [...res.data];
        console.log(this.tabList, 'list');
      }
    },
    async goUrl(item) {
      const { url, businessId: enquiryId } = item;
      if (url) {
        if (url.includes('/user/user/order/orderDetailOrApprove')) {
          window.open(`${mallBaseUrl}${url}`, '_blank');
          return;
        }
        this.$router.push({ path: url });
      } else {
        const result = await enApi.queryEnquiryDetailByEnquiryId({ enquiryId });
        if (result.code === '200') {
          const data = result.data;
          const { enquiryStatus, purchaseCompanyId } = data;
          const enUrl = '/enquiryManage/enquiry/enquiryDetail';
          this.$router.push({
            path: enUrl,
            query: {
              enquiryId,
              enquiryStatus,
              purchaseCompanyId,
            },
          });
        }
      }
    },
    handleClose() {
      this.$emit('update:trackVisibleDia', false);
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.track-dia {
  ::v-deep .el-dialog {
    .el-tabs__content {
      padding: 20px 0 0 10px;
      max-height: 300px;
      overflow: auto;
      .link {
        color: #0064c8;
        cursor: pointer;
      }
    }
    .el-dialog__header {
      background: #f5f5f5;
      height: 40px;
      padding: 0 20px;
      line-height: 40px;
      .el-dialog__headerbtn {
        top: 9px;
      }
      .el-dialog__title {
        font-size: 14px;
      }
    }
    .el-dialog__body {
      padding: 20px;
      .el-tabs {
        margin: 0 0 30px;
      }
      .el-table {
        min-height: 300px;
      }
      .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
        border-top: 2px #2587ff solid !important;
        background: #f4f7ff !important;
        line-height: 48px;
        color: #2587ff !important;
      }
      .el-tabs__header {
        margin: 0;
      }
      el-tabs__nav-wrap.is-scrollable {
        padding: 0;
      }
      .el-tabs__nav {
        border-radius: 0;
      }
      .el-tabs__item {
        border-top: 2px #fff solid;
        line-height: 48px;
        height: 48px;
        color: #333333 !important;
      }
    }
    .el-dialog__footer div {
      display: flex;
      justify-content: center;
      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
        padding: 0;
        border-radius: 0;
      }
      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-left: 20px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .default-btn {
        background: #fff;
        border: 1px solid #dcdfe6;
        &:hover {
          border-color: #2587ff;
          color: #2587ff;
        }
      }
    }
    .handle-btn {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
        padding: 0;
        border-radius: 0;
      }

      .default-btn {
        background: #fff;
        border: 1px solid #dcdfe6;
        &:hover {
          border-color: #2587ff;
          color: #2587ff;
        }
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-left: 20px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
    }
  }
}
</style>
